import _ from 'lodash';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import CreateUser from 'actions/users/create_user';
import EditableUser from 'models/editable_user';
import Err from 'models/err';
import NavigateBack from 'actions/current_location/navigate_back';
import RoutingGroup from 'models/routing_group';
import UpdateUser from 'actions/users/update_user';
import UserEditor from './user_editor';

const UserEditorContainerBase = connect(mapStateToProps, mapExecuteToProps)(UserEditor);

function mapStateToProps({ isFeatureEnabled }, props) {
  return {
    ...props,
    shouldRenderStationId: isFeatureEnabled('telephonyApi') || isFeatureEnabled('sip'),
  };
}

function mapExecuteToProps(executeAction, props) {
  return {
    onCancel: () => executeAction(NavigateBack),
    onSubmit: attrs => {
      props.initialUser && props.initialUser.isNew()
        ? executeAction(CreateUser, attrs)
        : executeAction(UpdateUser, attrs);
    },
  };
}

UserEditorContainerBase.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.instanceOf(Err)),
  initialUser: PropTypes.instanceOf(EditableUser),
  isResponsePending: PropTypes.bool,
  routingGroups: PropTypes.arrayOf(PropTypes.instanceOf(RoutingGroup)),
  userTeams: PropTypes.arrayOf(String),
};

const UserEditorContainer = connect(mapStateToPropsBase)(UserEditorContainerBase);

function mapStateToPropsBase({ getProvider, isFeatureEnabled }) {
  const userEditorProvider = getProvider('userEditor');
  const teamsProvider = getProvider('teams');
  const initialUser = userEditorProvider.get();
  let routingGroups = getProvider('routingGroups').findAll({ sortBy: rg => rg.name });
  return {
    errors: userEditorProvider.getErrors(),
    initialUser,
    isResponsePending: userEditorProvider.isPending(),
    routingGroups,
    userTeams:
      (initialUser &&
        teamsProvider
          .findAll({
            select: ['name'],
            filter: team => _.includes(team.agentIds, initialUser.id),
            sortBy: team => team.name.toLowerCase(),
          })
          .map(t => t.name)) ||
      [],
  };
}

export { UserEditorContainerBase };

export default UserEditorContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor_container.jsx